export default __webpack_public_path__ + "static/media/me.20bfabc7.png";